import { ACCESS_TOKEN, URI } from '../static/constants';
import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import XLSX from 'xlsx';
//import store from './store';



/** COMMON REQUEST HANDLER FOR ALL RESOURCES EXCEPT NON AUTHENTICATED RESOURCE LIKE LOGIN */
const request = (options) => {
    const headers = {
        'Content-Type': options.contentType ? options.contentType : 'application/json',
    };
    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);
    return axios(options).catch(error => {
        let defaultMessage = "We're sorry. There is something went wrong. Please, try again";
        let statusMessage = "";
        /* Default Message */
        if(error && error.response != null && error.response.status == 308){
            caches.keys().then((names) => {
                names.forEach(name => {
                    caches.delete(name);
                })
                window.location.replace(error.response.data)
              });
              return false;
        }else if (error && error.response != null && error.response.status !== null && error.response.status === 403) {
            defaultMessage = "We're sorry. You don't have permission to access the action you requested";
        } else if (error && error.response != null && error.response.data !== null) {
            defaultMessage = (error.response.data instanceof Object) ? defaultMessage : error.response.data.toString();
        }
        /* Status Message */
        if (error && error.response != null && error.response.status !== null && error.response.statusText != null) {
            statusMessage = error.response.status + " " + error.response.statusText;
        }
        NotificationManager.error(defaultMessage, statusMessage);
        return null;
    }).then((response) => {
        if (response !== null) {
            if (response.status === 200) {
                if (options.responseType != null && options.responseType === "blob") {
                    return response;
                }
                return response.data;
            } else {
                let reason = (response.data !== null) ? response.data.toString() : "";
                if (response.status === 204) {
                    NotificationManager.info("We're sorry. There is no data available for the input parameters provided.", response.status + " " + response.statusText);
                } else {
                    NotificationManager.info(reason, response.status + " " + response.statusText);
                }
                return null;
            }
        }
        return null;
    });
};

/** DYNAMIC QUERY PARAM BUILDER BASED ON NAME OF PARAM  */
const requestParamBuilder = (params) => {
    let requestQuery = "";
    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            if (params[key] !== null && params[key].toString() !== "") {
                requestQuery = requestQuery + (requestQuery.length !== 0 ? "&" : "?") + key + "=" + params[key].toString()
            }
        }
    }
    return requestQuery;
}

/** EXCEL EXPORT FOR TABLE DATA  */
export function exportXLSX(header, items, filename = "export.xlsx") {

    if ((items instanceof Array) && (header instanceof Object)) {
        let headerList = Object.keys(header);
        if (headerList.length > 0) {
            let rows = [headerList];
            items.forEach((item) => {
                let row = [];
                headerList.forEach((h) => {
                    row.push(getValue(item, header[h]));
                })
                rows.push(row)
            })
            const wb = XLSX.utils.book_new()
            const wsAll = XLSX.utils.aoa_to_sheet(rows)
            XLSX.utils.book_append_sheet(wb, wsAll)
            XLSX.writeFile(wb, filename)
        }
    }
}

function getValue(item, path, separator = '.') {
    let keys = path.split(separator).slice();
    if (keys instanceof Array) {
        keys.forEach((key) => {
            item = item[key];
        });
        return item;
    } else {
        return "";
    }

}

/** LOGIN RESOURCES  */
export function login(loginRequest) {
    const encodedString = new Buffer(loginRequest.username + ":" + loginRequest.password).toString('base64');
    return axios(URI.auth.auth, {
        method: 'GET',
        headers: {
            "Authorization": "Basic " + encodedString
        }
    }
    ).then(response => {
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        } return null;
    });
}

export function loginEmail(username) {
    return axios(URI.auth.username + username, {
        method: 'GET'
    }
    ).then(response => {
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        } return null;
    });
}

/** LOGIN RESOURCES  */
export function loadConfig() {
    return axios(URI.config, {
        method: 'GET',
    }
    ).then(response => {
        if (response.status === 200) {
            return response.data;
        } return null;
    });
}

export function loadHoldList() {
    return axios(URI.hold, {
        method: 'GET',
    }
    ).then(response => {
        if (response.status === 200 && response.data instanceof Object) {
            return response.data;
        } return null;
    });
}

export function forgotPassword(data, params) {

    return axios(URI.auth.reset + requestParamBuilder(params), {
        method: 'POST',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        }
    }
    ).then(response => {
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        } return null;
    });
}

export function resetPassword(data, params) {

    return axios(URI.auth.reset + requestParamBuilder(params), {
        method: 'PATCH',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        }
    }
    ).then(response => {
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        } return null;
    });
}

export function checkResetPassword(params) {

    return axios(URI.auth.reset + requestParamBuilder(params), {
        method: 'GET',
    }
    ).then(response => {
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        } return null;
    }).catch(error => {
        return null
    });
}

export function logout() {
    return request({
        url: URI.auth.auth,
        method: 'DELETE'
    });
}

export function getCurrentUser() {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }
}

/** GET DASHBOARD DETAILS */

export function getDashBoardDetails(cltCorporateId) {
    return request({
        url: URI.auth.dashboard.replace("{cltCorporateId}", cltCorporateId),
        method: 'GET'
    });
}

/** USER RESOURCES  */
export function getUserProfile() {
    return request({
        url: URI.auth.profile,
        method: 'GET'
    });
}

export function getUserCorporate() {
    return request({
        url: URI.auth.corporate,
        method: 'GET'
    });
}

export function getUsers(cltCorporateId, params, showall) {
    if (showall) {
        return request({
            url: URI.administration.users + requestParamBuilder(params),
            method: 'GET'
        });

    } else {
        return request({
            url: URI.administration.corporate.users.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
            method: 'GET'
        });
    }
}


export function deleteUsers(id) {
    return request({
        url: URI.administration.users + "/" + id,
        method: 'DELETE'
    });
}

export function getUserInfo(id) {
    return request({
        url: URI.administration.users + "/" + id,
        method: 'GET'
    });
}

export function changePassword(data) {
    return request({
        url: URI.auth.auth,
        method: 'PATCH',
        data: JSON.stringify(data)
    });
}

export function changeUserPassword(data) {
    return request({
        url: URI.administration.users + "/" + data.param,
        method: 'PATCH',
        data: JSON.stringify(data.body)
    });
}

export function saveUserDetails(data) {
    return request({
        url: URI.administration.users,
        method: 'POST',
        data: JSON.stringify(data)
    });
}


export function createOrUpdateUser(data) {
    if (data.usrId > 0) {
        return request({
            url: URI.administration.users + "/" + data.usrId,
            method: 'PUT',
            data: JSON.stringify(data)
        });
    } else {
        return request({
            url: URI.administration.users,
            method: 'POST',
            data: JSON.stringify(data)
        });

    }
}

export function updateProfile(data) {
    return request({
        url: URI.auth.profile,
        method: 'PATCH',
        data: JSON.stringify(data)
    })
}

/** MENU RESOURCE  */
export function getMenu() {
    return request({
        url: URI.auth.menu,
        method: 'GET'
    });
}

/** ALL REPORT RESOURCES  */

export function getAckReport(cltCorporateId, params) {
    return request({
        url: URI.report.acknowledgement.report.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getAckReportDates(cltCorporateId, params) {
    return request({
        url: URI.report.acknowledgement.dates.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
    })
}

export function getActuaryReport(cltCorporateId, params) {
    return request({
        url: URI.report.actuary.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getCancellationReport(cltCorporateId, params) {
    return request({
        url: URI.report.cancellation.report.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getCancellationReportDates(cltCorporateId, params) {
    return request({
        url: URI.report.cancellation.dates.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
    })
}

export function getCashflowReport(cltCorporateId, params) {
    return request({
        url: URI.report.cashflow.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getPaymentReport(cltCorporateId, params) {
    return request({
        url: URI.report.payment.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getInventoryReport(cltCorporateId, data) {
    return request({
        url: URI.report.inventory.report.replace("{cltCorporateId}", cltCorporateId),
        method: 'POST',
        data: JSON.stringify(data),
        responseType: 'blob'
    })
}


export function runInventoryReportById(cltCorporateId, issId) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId) + "/run/" + issId,
        method: 'GET',
        responseType: 'blob'
    })
}

export function postSaveSearch(cltCorporateId, data) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId),
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export function putSaveSearch(cltCorporateId, data) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId) + "/" + data.issId,
        method: 'PUT',
        data: JSON.stringify(data)
    })
}

export function patchSaveSearch(cltCorporateId, data) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId) + "/" + data.issId,
        method: 'PATCH',
        data: JSON.stringify(data)
    })
}

export function getMineSavedSearch(cltCorporateId) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId),
        method: 'GET'
    })
}

export function getAllSavedSearch(cltCorporateId) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId) + "?showAll=true",
        method: 'GET'
    })
}

export function getSavedSearch(cltCorporateId, issId) {
    return request({
        url: URI.report.inventory.searchTemplate.replace("{cltCorporateId}", cltCorporateId) + "/" + issId,
        method: 'GET'
    })
}

export function getTrustReport(cltCorporateId, params) {
    return request({
        url: URI.report.trust.report.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
        responseType: 'blob'
    })
}

export function getTrustReportDates(cltCorporateId, params) {
    return request({
        url: URI.report.trust.dates.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET',
    })
}

export function getStatusCodes() {
    return request({
        url: URI.accountManagement.statusCode,
        method: 'GET',
    })
}


/** REPORT END */

export function getInquiryDetails(cltCorporateId, params) {

    return request({
        url: URI.accountManagement.searchConsumer.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getInquiryAccountDetails(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.searchAccount.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getConsumerDetails(id) {
    return request({
        url: URI.accountManagement.getConsumer + "/" + id,
        method: 'GET'
    })
}


export function getConsumerHistory(id, type) {
    return request({
        url: URI.accountManagement.getConsumerHistory.replace("{conConsumerId}", id) + "?type=" + type,
        method: 'GET'
    })
}

export function getConsumePayments(cltCorporateId, id) {
    return request({
        url: URI.accountManagement.getConsumerPayments.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", id),
        method: 'GET'
    })
}

export function getConsumePaymentsById(cltCorporateId, consumerId, payPaymentId) {
    return request({
        url: URI.accountManagement.getConsumerPaymentsById.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", consumerId).replace("{payPaymentId}", payPaymentId),
        method: 'GET'
    })
}

export function getConsumerAccounts(cltCorporateId, id) {
    return request({
        url: URI.accountManagement.getAllAccounts.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", id) + "?openAccounts=false",
        method: 'GET'
    })
}

export function putConsumerInfo(id, data) {
    return request({
        url: URI.accountManagement.getConsumer + "/" + id,
        method: 'PUT',
        data: JSON.stringify(data)
    })
}

export function getRequestedHoldInfo(cltCorporateId, cltClientIds) {
    return request({
        url: URI.accountManagement.holds.holds.replace("{cltCorporateId}", cltCorporateId) + "?cltClientIds=" + cltClientIds.toString(),
        method: 'GET'
    })
}

export function getPendingCancellationsInfo(cltCorporateId, params) {
    return request({
        url: URI.cancellation.list.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getPaymentsSubmissionInfo(cltCorporateId, params) {
    return request({
        url: URI.payments.pending.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getClientAlertsInfo(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.clientAlert.alerts.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getClientAlertsHistory(cltCorporateId, conConsumerId, acoAccountId) {
    return request({
        url: URI.accountManagement.clientAlert.history.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", conConsumerId).replace("{acoAccountId}", acoAccountId),
        method: 'GET'
    })
}

export function resolveSuit(cltCorporateId, params, data) {
    return request({
        url: URI.accountManagement.clientAlert.alerts.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export function uploadAlertFile(data) {
    return request({
        url: URI.accountManagement.clientAlert.upload,
        method: 'POST',
        data: data,
        contentType: 'multipart/form-data'
    });
}

export function uploadDocuments(cltCorporateId, acoAccountId, data) {
    return request({
        url: URI.accountManagement.clientAlert.documents.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", acoAccountId),
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export function resolveDoc(cltCorporateId, data) {

    let suitData = {
        'acoAccountId': data.acoAccountId,
        'conConsumerId': data.conConsumerId,
        'documentId': data.documentId,
        'documentType': data.documentType,
        'isMatter': data.isMatter
    };

    if(typeof data.comment == 'string'){
        suitData['comment'] = data.comment;
    }

    return request({
        url: URI.accountManagement.clientAlert.alerts.replace("{cltCorporateId}", cltCorporateId),
        method: 'POST',
        data: JSON.stringify(suitData)
    })
}

export function getPastSubmission(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.pastsubmission.submitted.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function postCancellation(cltCorporateId, data) {
    return request({
        url: URI.cancellation.cancel.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", data.acoAccountId),
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export function postHold(cltCorporateId, data) {

    return request({
        url: URI.accountManagement.holds.account.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", data.acoAccountId),
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export function patchHold(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.holds.account.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", data.acoAccountId),
        method: 'PATCH',
        data: JSON.stringify(data)
    })
}

export function resolveHold(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.holds.account.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", data.acoAccountId),
        method: 'DELETE',
        data: JSON.stringify(data)
    })
}

export function patchConsumerHold(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.holds.consumer.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", data.acoConsumerId),
        method: 'PATCH',
        data: JSON.stringify(data)
    })
}

export function resolveConsumerHold(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.holds.consumer.replace("{cltCorporateId}", cltCorporateId).replace("{conConsumerId}", data.acoConsumerId),
        method: 'DELETE',
        data: JSON.stringify(data)
    })
}

export function getUserCorpBatch(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.pastsubmission.staging.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function deleteAccountFromBatch(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.pastsubmission.staging.replace("{cltCorporateId}", cltCorporateId),
        method: 'DELETE',
        data: JSON.stringify(data)
    })
}

export function createBatch(method, cltCorporateId, data) {
    return request({
        url: URI.accountManagement.pastsubmission.staging.replace("{cltCorporateId}", cltCorporateId),
        method: method,
        data: JSON.stringify(data)
    })
}

export function finalizeBatch(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.pastsubmission.batches.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'POST'
    })
}


export function getAccountDetails(cltCorporateId, acoAccountId) {
    return request({
        url: URI.accountManagement.getAccountById.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", acoAccountId),
        method: 'GET'
    })
}

export function postAccountPayment(cltCorporateId, post, data) {
    return request({
        url: URI.payments.account.replace("{cltCorporateId}", cltCorporateId).replace("{acoAccountId}", data.acoAccountId) + requestParamBuilder({ post: post }),
        method: 'POST',
        data: JSON.stringify(data)
    })
}



export function getBatchDetails(cltCorporateId, params) {
    return request({
        url: URI.accountManagement.pastsubmission.batches.replace("{cltCorporateId}", cltCorporateId) + requestParamBuilder(params),
        method: 'GET'
    })
}

export function getMails(params) {
    return request({
        url: URI.mail.mail + requestParamBuilder(params),
        method: 'GET'
    });
}

export function getMailsBySearchedText(params, searchValue) {
    var urk = URI.mail.search
    return request({
        url: URI.mail.search + requestParamBuilder(params),
        data: searchValue,
        method: 'POST'
    });
}

export function getMailContent(msgId, params) {
    return request({
        url: URI.mail.mailContent.replace("{mailId}", msgId) + requestParamBuilder(params),
        method: 'GET'
    });
}

export function moveMailsFromFolder(mailId, params) {
    return request({
        url: URI.mail.mail + requestParamBuilder(params),
        method: 'PATCH',
        data: JSON.stringify(mailId)
    });
}

export function deleteMailsFromFolder(mailId, params) {
    return request({
        url: URI.mail.mail + requestParamBuilder(params),
        method: 'DELETE',
        data: JSON.stringify(mailId)
    });
}

export function moveMailFromFolder(mailId, params) {
    return request({
        url: URI.mail.mailContent.replace("{mailId}", mailId) + requestParamBuilder(params),
        method: 'PATCH'
    });
}

export function deleteMailFromFolder(mailId, params) {
    return request({
        url: URI.mail.mailContent.replace("{mailId}", mailId) + requestParamBuilder(params),
        method: 'DELETE'
    });
}
export function saveMail(method, data, params) {
    return request({
        url: URI.mail.saveMail + requestParamBuilder(params),
        method: method,
        data: JSON.stringify(data)
    });
}

export function getMailUsers(cltCorporateId) {
    return request({
        url: URI.mail.users.replace("{cltCorporateId}", cltCorporateId),
        method: 'GET'
    });
}


export function getUnreadCount() {
    return request({
        url: URI.mail.unread,
        method: 'GET'
    });
}

export function uploadFile(data) {
    return request({
        url: URI.mail.upload,
        method: 'POST',
        data: data,
        contentType: 'multipart/form-data'
    });
}


export function downloadFile(id) {
    return request({
        url: URI.mail.download + "/" + id,
        method: 'GET',
        responseType: 'blob'
    });
}

export function listAccountDocuments(acoAccountId) {
    return request({
        url: URI.accountManagement.documents.replace("{acoAccountId}", acoAccountId),
        method: 'GET'
    });
}

export function uploadAccountDocuments(acoAccountId, data) {
    return request({
        url: URI.accountManagement.documents.replace("{acoAccountId}", acoAccountId),
        method: 'POST',
        data: data,
        contentType: 'multipart/form-data'
    });
}


export function downloadAccountDocuments(acoAccountId, documentId) {
    return request({
        url: URI.accountManagement.documents.replace("{acoAccountId}", acoAccountId) + "/" + documentId + "?download=true",
        method: 'GET',
        responseType: 'blob'
    });
}

export function getNotifications(usrId) {
    if(usrId == undefined){
        usrId = 0;
    }
    return request({
        url: URI.administration.notifications.replace("{usrId}", usrId),
        method: 'GET'
    });
}


export function getUploadedEdiFile(cltCorporateId) {
    return request({
        url: URI.accountManagement.ediFileUpload.replace("{cltCorporateId}", cltCorporateId),
        method: 'GET',
    });
}

export function uploadEdiFile(cltCorporateId, data) {
    return request({
        url: URI.accountManagement.ediFileUpload.replace("{cltCorporateId}", cltCorporateId),
        method: 'POST',
        data: data,
        contentType: 'multipart/form-data'
    });
}

export function downloadEdiFile(cltCorporateId, id) {
    return request({
        url: URI.accountManagement.ediFileDownload.replace("{cltCorporateId}", cltCorporateId).replace("{id}", id),
        method: 'GET',
        responseType: 'blob'
    });
}

export function getIdentityManagers(params) {
    return request({
        url: URI.administration.identityManager + requestParamBuilder(params),
        method: 'GET'
    });
}

export function deleteIdentityManager(id) {
    return request({
        url: URI.administration.identityManager + "/" + id,
        method: 'DELETE'
    });
}

export function getIdentityManager(id) {
    return request({
        url: URI.administration.identityManager + "/" + id,
        method: 'GET'
    });
}

export function createOrUpdateIdentity(data) {
    if (data.limId > 0) {
        return request({
            url: URI.administration.identityManager + "/" + data.limId,
            method: 'PUT',
            data: JSON.stringify(data)
        });
    } else {
        return request({
            url: URI.administration.identityManager,
            method: 'POST',
            data: JSON.stringify(data)
        });

    }
}

export function getIdentityMappings(params) {
    return request({
        url: URI.administration.identityMapping + requestParamBuilder(params),
        method: 'GET'
    });
}

export function deleteIdentityMapping(id) {
    return request({
        url: URI.administration.identityMapping + "/" + id,
        method: 'DELETE'
    });
}

export function getIdentityGroup(id) {
    return request({
        url: URI.administration.identityMapping + "/" + id,
        method: 'GET'
    });
}

export function getTemplates() {
    return request({
        url: URI.administration.template,
        method: 'GET'
    });
}

export function createOrUpdateIdentityGroup(data) {
    if (data.iimId > 0) {
        return request({
            url: URI.administration.identityMapping + "/" + data.iimId,
            method: 'PUT',
            data: JSON.stringify(data)
        });
    } else {
        return request({
            url: URI.administration.identityMapping,
            method: 'POST',
            data: JSON.stringify(data)
        });

    }
}

export function getLoginProviders() {
    return request({
        url: URI.administration.providers,
        method: 'GET'
    });
}

export function searchClientByValues(params) {
    return request({
        url: URI.clientManagement.search + requestParamBuilder(params),
        method: 'GET'
    });
}

export function getClientNAD(clientId) {
    return request({
        url: URI.clientManagement.clientNAD.replace("{clientId}", clientId),
        method: 'GET'
    });
}

export function getClientHistoryNotes(clientId) {
    return request({
        url: URI.clientManagement.clientComments.replace("{clientId}", clientId),
        method: 'GET'
    });
}

export function getSpecialNotes(clientId) {
    return request({
        url: URI.clientManagement.specialNote.replace("{clientId}", clientId),
        method: 'GET'
    });
}

export function getSalesActionHistory(clientId) {
    return request({
        url: URI.clientManagement.clientActions.replace("{clientId}", clientId),
        method: 'GET'
    });
}

export function getCreditManagers(clientId) {
    return request({
        url: URI.clientManagement.clientCreditManagers.replace("{clientId}", clientId),
        method: 'GET'
    });
}

export function loadActionCodes(type) {
    return request({
        url: URI.actionCode + type,
        method: 'GET',
    })
}

export function updateClientNAD(date, clientId) {
        return request({
            url: URI.clientManagement.clientPutNAD.replace("{clientId}", clientId) + date,
            method: 'PUT'
        });
}

export function loadClientIdsByCorporate(corporateId) {
    return request({
        url: URI.clientManagement.corporateNAD.replace("{corporateId}", corporateId),
        method: 'GET',
    })
}

export function addSpecialNotes(clientId, specialNote) {
    return request({
        url: URI.clientManagement.specialNote.replace("{clientId}", clientId),
        method: 'POST',
        data: JSON.stringify(specialNote)
    });
}

export function addClientActionComment(clientId, actionCode) {
    return request({
        url: URI.clientManagement.clientActions.replace("{clientId}", clientId),
        method: 'POST',
        data: JSON.stringify(actionCode)
    });
}

export function getCurrencyCodes() {
    return request({
        url: URI.currencyCodes,
        method: 'GET',
    });
}


// WEBPACK FOOTER //
// ./src/app/utils/rest.js